module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAAAAXNSR0IArs4c6QAAAOZJREFUKFON0a9KREEUx/HvV2ENtk1m6yLin6SYfAJfQMEkWK1aTOsLWE2CySIIBsM2QRAF476AiCaT4k9G7pX1cmWdNmfmc86ZOSbpAB/qJ2NWkglg0iQnwI16/A90AHQL6gHXwJz69BdMsgacAUuWS0n6wIy61YaSdIE7YEe9rNE08AhsqoMmTHIODNW9cvaNqmobwCGwoL6PxHeB0sFqHf9BFbwABupRtZ8HroAVdVgnaqLZ8pPAIvAC3Jbq6uloy79QlX2/tAi8lvbV7eYb29AU8ACUYS+rb2NRVW0deFbv20bwBV64V7FI2yuyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Next.png
// module id = fP/L
// module chunks = 26